import * as React from "react";
import { WidgetFrame } from "../../../personal-studio-components/studio";
import { TextCard } from "../../../personal-studio-components/studio";
import { Form, FormActions, Button } from "../../../personal-studio-components/form/index.js";
import { OTRS } from "../../../personal-studio-components/studio";

/**
 * Виджет для отображения ошибки доступа
 * @returns {JSX.Element} Виджет с сообщением об ошибке
 * @example
 * <NotAuthorized />
 */
function NotAuthorized() {
  const errorMessage = "Данный раздел доступен только обучающимся";
  const errorHtml = errorMessage.split("\n").map(
    (line, i) => <p key={i}>{line}</p>
  );

  OTRS.body = errorMessage.replace(/\n/g, "<br/>");

  return (
    <WidgetFrame
      type="danger"
      icon="warn"
      title="Произошла ошибка"
    >
      <Form onSubmit={(event) => { event.preventDefault(); location.reload(); }}>
        <TextCard type="danger">
          <div style={{ padding: "16px", fontSize: '1rem', fontWeight: 'bold' }}>
            {errorHtml}
          </div>
        </TextCard>
        <FormActions>
          <Button
            type="primary"
            icon="play_circle"
            onClick={(event) => { 
              event.preventDefault(); 
              location.reload(); 
            }}
          >
            Повторить
          </Button>
          <Button
            icon="close_circle"
            onClick={(event) => { 
              event.preventDefault(); 
              location.reload(); 
            }}
          >
            Перезагрузить
          </Button>
          <Button
            icon="chat"
            onClick={OTRS.onClick}
          >
            Техническая помощь
          </Button>
        </FormActions>
      </Form>
    </WidgetFrame>
  );
}

export default NotAuthorized;